import type { ReportGalleryItem } from "./types";

interface ReportDetailPanelProps {
  item: ReportGalleryItem | null;
  title: string;
  emptyMessage: string;
}

export function ReportDetailPanel({ item, title, emptyMessage }: ReportDetailPanelProps) {
  return (
    <div className="space-y-4">
      <div>
        <p className="text-xs uppercase tracking-wider text-muted-foreground">
          {title}
        </p>
        {item ? (
          <>
            <h3 className="text-lg font-semibold text-foreground mt-1">
              {item.name}
            </h3>
            <p className="text-xs text-muted-foreground">
              {item.details.length} {item.details.length === 1 ? "attribute" : "attributes"}
            </p>
          </>
        ) : (
          <p className="text-sm text-muted-foreground mt-2">{emptyMessage}</p>
        )}
      </div>

      {item && item.details.length > 0 && (
        <div className="space-y-3">
          <p className="text-xs uppercase tracking-wider text-muted-foreground">
            Details
          </p>
          <dl className="space-y-3">
            {item.details.map(({ key, label, value }) => (
              <div key={key}>
                <dt className="text-xs uppercase tracking-wider text-muted-foreground">
                  {label}
                </dt>
                <dd className="text-sm text-foreground mt-0.5">{value}</dd>
              </div>
            ))}
          </dl>
        </div>
      )}

      {item?.extraContent && <div>{item.extraContent}</div>}
    </div>
  );
}
